import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bibShape } from '@bibliocommons/bc-prop-types';
import { BibJacketContainer } from 'app/components/bibs/shared/BibJacket';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import BibLink from 'app/components/shared/BibLink';

import './BibCard.scss';

export default function BibCard({ bib, number, isCurrentItem, source, handleBibTitle, handleBibImage }) {
  const cover = bib.get('coverImage');
  const metadataId = bib.get('metadataId');
  const title = bib.get('title');
  const volumeLabel = bib.get('volumeLabel');

  const renderJacketCover = () => (
    <BibJacketContainer placeholder={number} title={title} cover={cover} metadataId={metadataId} />
  );

  const renderTitle = () => <div className="bib-title">{title}</div>;

  function handleBibImageClick() {
    if (typeof handleBibImage === 'function') {
      handleBibImage({ bib, source });
    }
  }

  function handleBibTitleClick() {
    if (typeof handleBibTitle === 'function') {
      handleBibTitle({ bib, source });
    }
  }

  return (
    <div className="cp-bib-card">
      <div className="bib-card-contents">
        <div className="number">
          {number && !volumeLabel && (
            <>
              <span aria-hidden="true">{number}</span>
              <ScreenReaderMessage>
                <FormattedMessage id="seriesTitleNumber" values={{ number }} />
              </ScreenReaderMessage>
            </>
          )}
        </div>
        <div className="bib-wrapper">
          <BibLink metadataId={metadataId} handleClick={handleBibImageClick} isDecorative>
            {renderJacketCover()}
          </BibLink>
          <BibLink className="title-link" metadataId={metadataId} handleClick={handleBibTitleClick}>
            {renderTitle()}
          </BibLink>
          {isCurrentItem && (
            <div className="current-item-indicator">
              <FormattedMessage id="this_item" />
            </div>
          )}
          {volumeLabel && <>({volumeLabel})</>}
        </div>
      </div>
    </div>
  );
}

BibCard.propTypes = {
  bib: bibShape,
  number: PropTypes.number,
  isCurrentItem: PropTypes.bool,
  source: PropTypes.string,
  handleBibTitle: PropTypes.func,
  handleBibImage: PropTypes.func
};
